































import { Component, Vue, Emit, Prop } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import SolicitacaoCancelamentoStore from '@/components/SolicitacaoCancelamento/Store/SolicitacaoCancelamentoStore'
import BackofficeGlobalStore from '@/components/Backoffice/Store/BackofficeGlobalStore'
import BackofficeAgendamentoStore from '@/components/Backoffice/Store/BackofficeAgendamentoStore'
import BackofficeAutorizacaoStore from '@/components/Backoffice/Store/BackofficeAutorizacaoStore'
import { TipoOrigemEnum, RequestMessage, TipoUsuarioEnum, Solicitacao, SituacaoEnum } from '@/types/_'
import { timeoutDefault } from '@/utils/common'

import EventBus from '@/plugins/EventBus'

@Component

export default class ModalSolicitacaoCancelamentoAutorizacao extends Vue {
  @Prop({ required: true }) tipoUsuario: TipoUsuarioEnum

  loadCancelar: boolean = false
  loadVoltar: boolean = false

  get loadingCancelar() {
    return this.loadCancelar
  }

  set loadingCancelar(val: boolean) {
    this.loadCancelar = val
  }

  get loadingVoltar() {
    return this.loadVoltar
  }

  set loadingVoltar(val: boolean) {
    this.loadVoltar = val
  }

  get getSolicitacaoCancelamentoStore() {
    return getModule(SolicitacaoCancelamentoStore, this.$store)
  }

  get getBackofficeGlobalStore() {
    return getModule(BackofficeGlobalStore, this.$store)
  }

  get getBackofficeAgendamentoStore() {
    return getModule(BackofficeAutorizacaoStore, this.$store)
  }

  get getBackofficeAutorizacaoStore() {
    return getModule(BackofficeAutorizacaoStore, this.$store)
  }

  get showModal() {
    return this.getSolicitacaoCancelamentoStore.modal.cancelamentoAutorizacao
  }

  set showModal(value: boolean) {
    this.getSolicitacaoCancelamentoStore.setShowModalCancelamentoAutorizacao(value)
  }

  get getDisabledAutocomplete() {
    return this.getSolicitacaoCancelamentoStore.cancelarSolicitacaoParam.situacao.key === SituacaoEnum.CancelamentoSolicitado
  }

  async cancelamentoSolicitado(origem: TipoOrigemEnum) {
    if (this.isValid()) {
      this.loadingCancelar = true
      const response = await this.getSolicitacaoCancelamentoStore.solicitaCancelamentoSolicitacao(this.getSolicitacaoCancelamentoStore.motivo)
      if (response.success) {
        this.closeModal()
      } else {
        EventBus.$emit('setSnackbar', { show: true, text: response.message || 'Houve um problema no cancelamento da solicitação..', icon: 'warning', color: '#C62828' })
      }
      this.loadingCancelar = false
    }
  }

  isValid() {
    let valid: boolean = true
    if (['', null, undefined].includes(this.getSolicitacaoCancelamentoStore.motivo)) {
      valid = false
      this.getSolicitacaoCancelamentoStore.setMotivoMessage('Por favor informe o motivo.')
    } else {
      this.getSolicitacaoCancelamentoStore.setMotivoMessage('')
    }

    return valid
  }

  async voltar() {
    this.loadingVoltar = true
    await timeoutDefault()
    this.getSolicitacaoCancelamentoStore.setShowModalCancelamentoAutorizacao(false)
    this.getSolicitacaoCancelamentoStore.clear()
    this.loadingVoltar = false
  }

  async closeModal() {
    const { modal, solicitacaoId } = this.getSolicitacaoCancelamentoStore.cancelarSolicitacaoParam
    this.getSolicitacaoCancelamentoStore.setShowModalCancelamentoAutorizacao(false)
    this.getBackofficeGlobalStore.closeModalAguardandoCotacao()
    this.getBackofficeGlobalStore.setModal({ name: modal, value: false })

    switch (modal) {
      case 'triagem':
        await this.getBackofficeAgendamentoStore.loadAgendamentosMedicoSearch(solicitacaoId)
        break
      case 'iniciarProcesso':
      case 'autorizarProcesso':
      case 'atualizarAutorizacao':
      case 'autorizada':
        await this.getBackofficeAutorizacaoStore.loadAgendamentosMedicoSearch(solicitacaoId)
        break

      default:
        break
    }


    this.getSolicitacaoCancelamentoStore.clear()
  }
}

